import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LayersIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Layers",
    children: /*#__PURE__*/_jsx("path", {
      d: "m28.73 20.71-.84-.42a.84.84 0 0 0-.8.02l-9.84 5.6c-.84.4-1.67.4-2.45 0l-9.79-5.59a.86.86 0 0 0-.81-.02l-.83.42c-1.26.67-1.18 1.81 0 2.45L14.8 29.7c.78.4 1.61.4 2.45 0l11.49-6.53c1.14-.69 1.14-1.8 0-2.45Zm0-6.18-1.28-.63a.5.5 0 0 0-.45 0l-9.75 5.55c-.84.4-1.67.4-2.45 0L5.08 13.9a.45.45 0 0 0-.46 0l-1.28.63c-1.26.67-1.18 1.81 0 2.45l11.43 6.53c.78.4 1.61.4 2.45 0l11.49-6.53c1.14-.69 1.14-1.8 0-2.45zM3.35 10.49l11.43 6.53c.78.4 1.61.4 2.45 0l11.49-6.53c1.14-.69 1.14-1.8 0-2.45L17.26 2.35c-.87-.45-1.55-.47-2.45 0L3.35 8.04c-1.26.67-1.18 1.81 0 2.45"
    })
  }));
};